export default import.meta.ROLLDOWN_FILE_URL_RkDoXRZ$bx$5lf1haFcvQA